export default "__VITE_ASSET__iA7HYSET__"